import { render, staticRenderFns } from "./registerCompleteStarter.vue?vue&type=template&id=b019c484&scoped=true"
import script from "./registerCompleteStarter.vue?vue&type=script&lang=js"
export * from "./registerCompleteStarter.vue?vue&type=script&lang=js"
import style0 from "./registerCompleteStarter.vue?vue&type=style&index=0&id=b019c484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b019c484",
  null
  
)

export default component.exports